const {
  VITE_ENVIRONMENT: ENVIRONMENT,
  VITE_BASE_URL: BASE_URL,
  VITE_API_URL: API_URL,
  VITE_PEACH_PAY_WIDGET: PEACH_PAY_WIDGET,
  VITE_CUSTOMER_UI_URL: CUSTOMER_UI_URL,
  VITE_MERCHANT_UI_URL: MERCHANT_UI_URL,
  VITE_EMBEDDED_ENTITY_ID: EMBEDDED_ENTITY_ID,
  VITE_MAX_RETRY: MAX_RETRY,
  VITE_CLOUDINARY_NAME: CLOUDINARY_NAME,
  VITE_CLOUDINARY_UPLOAD_PRESET: CLOUDINARY_UPLOAD_PRESET,
  VITE_APP_GOOGLE_API_KEY: GOOGLE_API_KEY,
  VITE_BOOST_REWARDS_MIN_LENGTH: BOOST_REWARDS_MIN_LENGTH,
  VITE_BOOST_REWARDS_MAX_LENGTH: BOOST_REWARDS_MAX_LENGTH,
  VITE_BOOST_TERMS_AND_CONDITIONS_URL: BOOST_TERMS_AND_CONDITIONS_URL,
  VITE_CLOUDFLARE_SITE_KEY: CLOUDFLARE_SITE_KEY,
} = import.meta.env;

export {
  ENVIRONMENT,
  BASE_URL,
  API_URL,
  PEACH_PAY_WIDGET,
  CUSTOMER_UI_URL,
  MERCHANT_UI_URL,
  EMBEDDED_ENTITY_ID,
  MAX_RETRY,
  CLOUDINARY_NAME,
  CLOUDINARY_UPLOAD_PRESET,
  GOOGLE_API_KEY,
  BOOST_REWARDS_MIN_LENGTH,
  BOOST_REWARDS_MAX_LENGTH,
  BOOST_TERMS_AND_CONDITIONS_URL,
  CLOUDFLARE_SITE_KEY,
};
